import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';

import { getCompany, deleteCompany } from '../services/company.service';
import { FormDetailsItem, Breadcrumb } from '../../common/components';
import CompanyTabsComponent from './companyTabs.container';

class CompanyDetailsOverall extends PureComponent {
  state = {
    data: {},
    isLoading: true,
  };

  id = this.props.match.params.id;

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const {
      match: { params: routeParams },
    } = this.props;

    this.setState({
      isLoading: true,
    });

    const data = await getCompany(routeParams.id);

    this.setState({
      data,
      isLoading: false,
    });
  };

  editCompany = () => {
    const { history } = this.props;

    history.push(`/company/${this.id}`);
  };

  deleteCompany = async () => {
    const { history } = this.props;

    if (window.confirm('Jesteś pewien, ze chcesz usunąć firmę?')) {
      await deleteCompany(this.id);

      history.replace('/companies');
    }
  };

  render() {
    const { data, isLoading } = this.state;
    const { isAdmin } = this.props;
    let type;
    if (isLoading) {
      return null;
    }

    switch (data.type) {
      case 0:
        type = 'Komis';
        break;
      case 1:
        type = 'Stacja diagnostyczna';
        break;
      case 2:
        type = 'Administrator';
        break;
      default:
        break;
    }

    return (
      <>
        <Breadcrumb title="Szczegóły firmy">
          {isAdmin && (
            <div className="row no-gutters justify-content-end py-3">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={this.deleteCompany}
              >
                Usuń firmę
              </button>
              <button
                type="button"
                className="btn btn-outline-primary ml-2"
                onClick={this.editCompany}
              >
                Edytuj firmę
              </button>
            </div>
          )}
        </Breadcrumb>
        <div className="content">
          <CompanyTabsComponent active="overall" />
          <div className="card">
            <div className="card-body">
              <FormDetailsItem label="Nazwa" value={data.name} />
              <FormDetailsItem label="NIP" value={data.vatId} />
              {isAdmin && (
                <>
                  <FormDetailsItem label="Typ" value={type} />
                  <FormDetailsItem
                    label="Aktywny"
                    value={data.active ? 'Tak' : 'Nie'}
                  />
                  <FormDetailsItem
                    label="Grupa Klientów"
                    value={data.group && data.group.name}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        <div className="content">
          <div className="card">
            <div className="card-header">Dane adresowe</div>
            <div className="card-body">
              <FormDetailsItem
                label="Adres"
                value={_get(data, 'main_address.address')}
              />
              <FormDetailsItem
                label="Województwo"
                value={_get(data, 'main_address.voivodeship.name')}
              />
              <FormDetailsItem
                label="Miasto"
                value={_get(data, 'main_address.locality')}
              />
              <FormDetailsItem
                label="Ulica"
                value={`${_get(data, 'main_address.route', '')} ${_get(
                  data,
                  'main_address.street_number',
                  '',
                )}`}
              />
              <FormDetailsItem
                label="Kod pocztowy"
                value={_get(data, 'main_address.postal_code')}
              />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="card">
            <div className="card-header">Dane korespondencyjne</div>
            <div className="card-body">
              <FormDetailsItem
                label="Adres"
                value={_get(data, 'corespondence_address.address')}
              />
              <FormDetailsItem
                label="Województwo"
                value={_get(data, 'corespondence_address.voivodeship.name')}
              />
              <FormDetailsItem
                label="Miasto"
                value={_get(data, 'corespondence_address.locality')}
              />
              <FormDetailsItem
                label="Ulica"
                value={`${_get(data, 'corespondence_address.route', '')} ${_get(
                  data,
                  'corespondence_address.street_number',
                  '',
                )}`}
              />
              <FormDetailsItem
                label="Kod pocztowy"
                value={_get(data, 'corespondence_address.postal_code')}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(CompanyDetailsOverall);
